import React from 'react';
import { Link } from 'react-router-dom';
import useSiteConfig, { PLACEHOLDER } from '../hooks/useSiteConfig';

const About = () => {
  const c = useSiteConfig();
  return (
    <main style={{ maxWidth: 720, margin: '0 auto', padding: '4rem 1rem' }}>
      <h1>About {c.brand_name || 'FraxLandShare'}</h1>
      <p>
        {c.brand_name || 'FraxLandShare'} lets invited investors take part in individual land projects. Each project is held in its own
        company (an SPV), so investors own shares in that company and receive documents, updates and expense reports for that project.
      </p>
      <p>Operated by {c.operator_name || PLACEHOLDER} (CIN {c.operator_cin || PLACEHOLDER}).</p>
      <p>[ABOUT TEXT — TO BE PROVIDED]</p>
      <p>See <Link to="/investment-guide">how it works</Link> and the <Link to="/risk-disclosure">risk disclosure</Link>, or <Link to="/contact">contact us</Link>.</p>
    </main>
  );
};

export default About;
